module.exports = __webpack_public_path__ + "static/img/img4.cf2781f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img4.png
// module id = Zbgw
// module chunks = 1